import gql from 'graphql-tag';
import { auth0UserFieldsFragment } from '@graphql/admin/fragments';

export const addUserMutation = gql`
  mutation AddUser($input: AddUserInput!) {
    addUser(input: $input) {
      ...AdminAuth0UserFields
    }
  }

  ${auth0UserFieldsFragment}
`;